import { render, staticRenderFns } from "./ZoomableImage.vue?vue&type=template&id=3c98f9d0&scoped=true&"
import script from "./ZoomableImage.vue?vue&type=script&lang=ts&"
export * from "./ZoomableImage.vue?vue&type=script&lang=ts&"
import style0 from "./ZoomableImage.vue?vue&type=style&index=0&id=3c98f9d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c98f9d0",
  null
  
)

export default component.exports